import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter, Input,
  Output, ViewChild, ElementRef,
} from '@angular/core';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { FitmentYmmSearchComponent } from '../fitment-ymm-search/fitment-ymm-search.component';
import { ModalHeaderSearchComponent } from 'shared/modal/modal-header-search/modal-header-search.component';
import { columns } from './columns';


@Component({
  moduleId: module.id,
  selector: 'add-fitment-modal',
  templateUrl: 'add-fitment-modal.component.html',
  styleUrls: ['add-fitment-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddFitmentModalComponent extends BaseModalComponent {

  @Output() selectFitments: EventEmitter<Array<any>> = new EventEmitter();

  @ViewChild(FitmentYmmSearchComponent, {static: false})
  ymmSearch: FitmentYmmSearchComponent | void;

  @ViewChild(ModalHeaderSearchComponent, {static: false})
  headerSearch: ModalHeaderSearchComponent | void;

  sortingColumns: Array<any> = columns;

  constructor(
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  onClearClick() {
    if (this.ymmSearch instanceof FitmentYmmSearchComponent) {
      this.ymmSearch.resetData();
    }
  }

  onFitmentsSelect(fitments: Array<any>) {
    this.selectFitments.emit(fitments);
    this.hide();
  }

  onModalHide() {
    this.hide();
  }

  show() {
    super.show();
  }

  hide() {
    super.hide();
    this.resetData();
  }

  resetData(): void {
    if (this.ymmSearch instanceof FitmentYmmSearchComponent) {
      this.ymmSearch.resetData();
    }
    if (this.headerSearch instanceof ModalHeaderSearchComponent) {
      this.headerSearch.reset();
    }
  }

  runSearch(searchTerm: string): void {
    if (this.ymmSearch instanceof FitmentYmmSearchComponent) {
      this.ymmSearch.searching(searchTerm);
    }
  }
}
